<template>
    <b-nav-item-dropdown :right="right">
        <slot
            name="button-content"
            slot="button-content"
        />

        <slot />
    </b-nav-item-dropdown>
</template>

<script>
import {BNavItemDropdown} from 'bootstrap-vue'

export default {
    components: {BNavItemDropdown},
    props: {
        right: {type: Boolean},
    },
}
</script>